import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WishlistItem {
  id: number | string;
  name: string;
  price: number;
  image: string;
  description?: string;
  sales_rate?: number;
  status?: string;
  slug?: string;
}

interface WishlistState {
  items: WishlistItem[];
  totalItems: number;
}

const initialState: WishlistState = {
  items: [],
  totalItems: 0,
};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    // Add item to wishlist
    addToWishlist: (state, action: PayloadAction<WishlistItem>) => {
      const existingItem = state.items.find((item) => item.id === action.payload.id);
      
      if (!existingItem) {
        state.items.push(action.payload);
        state.totalItems = state.items.length;
      }
    },

    // Remove item from wishlist
    removeFromWishlist: (state, action: PayloadAction<number | string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
      state.totalItems = state.items.length;
    },

    // Toggle item in wishlist (add if not present, remove if present)
    toggleWishlistItem: (state, action: PayloadAction<WishlistItem>) => {
      const existingItemIndex = state.items.findIndex((item) => item.id === action.payload.id);
      
      if (existingItemIndex !== -1) {
        // Remove if already in wishlist
        state.items.splice(existingItemIndex, 1);
      } else {
        // Add if not in wishlist
        state.items.push(action.payload);
      }
      
      state.totalItems = state.items.length;
    },

    // Clear all items from wishlist
    clearWishlist: (state) => {
      state.items = [];
      state.totalItems = 0;
    },

  },
});

// Export action creators
export const {
  addToWishlist,
  removeFromWishlist,
  toggleWishlistItem,
  clearWishlist,
} = wishlistSlice.actions;

// Export reducer
export default wishlistSlice.reducer;
